<template>
  <div id="app">
    <!-- <p id="test" @click="test">
      dsdashdsahkdj
    </p> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view"></router-view>
      <!-- <router-view v-if="$route.meta.keepAlive" class="router-view"></router-view> -->
      <index v-else></index>
    </keep-alive>
  </div>
</template>
<script>
import index from "./components/index";
export default {
  name: "app",
  components: { index },
  methods: {
  
  }
};
</script>

<style >
#app {
}

input,
button {
  outline: none;
}
.mint-toast {
  z-index: 10000 !important;
}
</style>
